import React from "react";
import {isMobile} from "react-device-detect";
import {HOME_PLAYLIST} from "constant/playlist.display";
import PlaylistItem from "./PlaylistItem";


const PlaylistHomeItem = ({ playlist, inflowPath }) => {

    const checkPlaylistUcc = playlist.playlistUcc.filter((data, key) => {
        if (data.bbsTitle.length <= 0) return false;
        if (key >= 4) return false;

        return data;
    });

    return (

        checkPlaylistUcc.map((data, idx) => {

            const { playlistUcc, count:playlistCount, ...other } = playlist;
            const { bbsTitle, ...playOther } = data;
            const { count, ...title } = bbsTitle[0];
            const playlistUser = {
                playlist : {
                    ...other,
                    playlistUcc: playOther,
                    count : {
                        ...count,
                        playlist_cnt: playlistCount
                    },
                    bbsTitle : bbsTitle[0],

                }
            };

            return (
                <div className="vod-box" key={idx}>
                    {/*<VodItem inflowPath={inflowPath} vod={data.bbsTitle[0]} thumbHeight={117} pageType={PLAYLIST_VODS}/>*/}
                    <PlaylistItem playlistUser={playlistUser} inflowPath={inflowPath} thumbHeight={isMobile ? 117 : 86} playlistPathType={HOME_PLAYLIST} />
                </div>
            );
        })
    );
}

export default PlaylistHomeItem;